/*
 * File: ui-quicks.ts
 * File Created: 2024-09-05 05:20:14
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-25 10:29:28
 * Modified By: Val Liu
 * -----
 */

import { AnyHelper, IQuickUnit } from "@root/core";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";

/// @uiQuicks - to easily set `quick` / `quicks` / `quick-parent`.
interface IUIQuicks {
    quick?: IQuickUnit;
    quicks?: IQuickUnit[];
    "quick-parent"?: IQuickUnit;
}

@UITag.set()
export class uiQuicks extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.TableBodyCell,
        EUITagTarget.FormElement,
        EUITagTarget.FormSubmit,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = false;

    /// set prop sortable: true / false
    parse(input: IUITagInput): IUITagResult {
        /// default: true
        /// rule: true / false
        const rule = this.parseRule(input);

        return {
            props: {
                ...rule,
            },
        };
    }
}
